// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.padding-wrapper-content-list-widget {
  padding: 0 10px 16px 16px;
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 10px;
}

.adv-parent-temp-wrapper-list-widget {
  display: inline-block;
  width: 100%;
  height: 100%;
  border-radius: 4px;
  box-shadow: 0px 1px 2px -1px rgba(16, 24, 40, 0.1), 0px 1px 3px 0px rgba(16, 24, 40, 0.1);
  background: var(--sdk-global-white-bg);
}
.adv-parent-temp-wrapper-list-widget.list-with-border-multi-items .adv-parent-acc-list:last-child::before {
  display: none;
}
.adv-parent-temp-wrapper-list-widget.list-with-border-multi-items .adv-parent-acc-list::before {
  content: "";
  position: absolute;
  width: calc(100% - 20px);
  height: 1px;
  background: var(--sdk-gloabl-border-color);
  bottom: 0;
  left: 10px;
}
.adv-parent-temp-wrapper-list-widget .tabs-sec-data {
  padding: 0px 10px;
  display: flex;
  gap: 8px 16px;
  flex-wrap: wrap;
  margin-bottom: 10px;
}
.adv-parent-temp-wrapper-list-widget .tabs-sec-data .tab-name {
  border: 0;
  color: var(--sdk-gloabl-text-color);
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  padding: 10px 12px;
  min-width: 44px;
  min-height: 44px;
  border-bottom: 2px solid var(--sdk-global-white-bg);
  background: var(--sdk-global-white-bg);
  transition: 0.3s all ease;
}
.adv-parent-temp-wrapper-list-widget .tabs-sec-data .tab-name:hover {
  border-bottom: 2px solid var(--sdk-global-theme-color);
}
.adv-parent-temp-wrapper-list-widget .tabs-sec-data .tab-name.active-tab {
  border-bottom: 2px solid var(--sdk-global-theme-color);
}
.adv-parent-temp-wrapper-list-widget .drp-content-menu {
  display: none;
  position: absolute;
  left: auto;
  right: 0;
  z-index: 9;
  border: 1px solid var(--sdk-gloabl-border-color);
  box-shadow: 0px 2px 4px -2px rgba(16, 24, 40, 0.1), 0px 4px 6px -1px rgba(16, 24, 40, 0.1);
  background: var(--sdk-global-white-bg);
  margin-top: 2px;
  top: 34px;
  border-radius: 4px;
  width: 200px;
}
.adv-parent-temp-wrapper-list-widget .drp-content-menu .close-drp-down {
  float: right;
  border: 0;
  padding: 0;
  background: transparent;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  cursor: pointer;
  margin: 5px;
}
.adv-parent-temp-wrapper-list-widget .drp-content-menu .close-drp-down svg path {
  fill: var(--sdk-gloabl-text-color);
}
.adv-parent-temp-wrapper-list-widget .drp-content-menu li {
  border-radius: 4px 4px 0px 0px;
  background: var(--sdk-global-white-bg);
  display: flex;
  padding: 5px 16px;
  width: 100%;
  align-items: center;
  align-self: stretch;
  gap: 10px;
  cursor: pointer;
  transition: 0.2s all ease;
  list-style-type: none;
}
.adv-parent-temp-wrapper-list-widget .main-heading-wrapper {
  padding: 10px;
  display: flex;
  align-items: center;
  gap: 10px;
}
.adv-parent-temp-wrapper-list-widget .main-heading-wrapper h1 {
  color: var(--sdk-gloabl-text-color);
  font-size: 18px;
  font-weight: 600;
  line-height: 20px;
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.adv-parent-temp-wrapper-list-widget .main-heading-wrapper p {
  padding: 0;
  white-space: normal;
  font-size: 13px;
  letter-spacing: 0.27px;
  color: #8a959f;
  text-overflow: ellipsis;
}
.adv-parent-temp-wrapper-list-widget .main-heading-wrapper .header-actions {
  display: flex;
  align-items: center;
  flex-shrink: 0;
  gap: 10px;
  position: relative;
}
.adv-parent-temp-wrapper-list-widget .adv-parent-acc-list {
  display: inline-block;
  width: 100%;
  height: 100%;
  position: relative;
}
.adv-parent-temp-wrapper-list-widget .adv-parent-acc-list.open-acc-adv-temp .advanced-list-template-wrapper .right-actions-content .arrow-icon {
  transform: rotate(90deg);
}
.adv-parent-temp-wrapper-list-widget .adv-parent-acc-list.open-acc-adv-temp .adv-list-temp-accordion {
  display: block;
}
.adv-parent-temp-wrapper-list-widget .adv-parent-acc-list .advanced-list-template-wrapper {
  width: 100%;
  display: flex;
  align-items: center;
  padding: 10px;
  gap: 15px;
}
.adv-parent-temp-wrapper-list-widget .adv-parent-acc-list .advanced-list-template-wrapper .img-block {
  flex-shrink: 0;
  width: 40px;
  height: 40px;
}
.adv-parent-temp-wrapper-list-widget .adv-parent-acc-list .advanced-list-template-wrapper .img-block.xs {
  width: 16px;
  height: 16px;
}
.adv-parent-temp-wrapper-list-widget .adv-parent-acc-list .advanced-list-template-wrapper .img-block.lg {
  width: 60px;
  height: 60px;
}
.adv-parent-temp-wrapper-list-widget .adv-parent-acc-list .advanced-list-template-wrapper .img-block.xlg {
  width: 80px;
  height: 80px;
}
.adv-parent-temp-wrapper-list-widget .adv-parent-acc-list .advanced-list-template-wrapper .img-block figure {
  line-height: 0px;
}
.adv-parent-temp-wrapper-list-widget .adv-parent-acc-list .advanced-list-template-wrapper .img-block img {
  width: 100%;
  height: 100%;
  border-radius: 8px;
}
.adv-parent-temp-wrapper-list-widget .adv-parent-acc-list .advanced-list-template-wrapper .img-block img.radius-100 {
  border-radius: 100%;
}
.adv-parent-temp-wrapper-list-widget .adv-parent-acc-list .advanced-list-template-wrapper .titles-info-block {
  width: 100%;
}
.adv-parent-temp-wrapper-list-widget .adv-parent-acc-list .advanced-list-template-wrapper .titles-info-block h1 {
  color: var(--sdk-gloabl-text-color);
  font-size: 16px;
  font-weight: 600;
  line-height: normal;
}
.adv-parent-temp-wrapper-list-widget .adv-parent-acc-list .advanced-list-template-wrapper .titles-info-block p {
  color: var(--sdk-gloabl-text-color);
  font-size: 14px;
  font-weight: 400;
  line-height: normal;
  letter-spacing: 0.271px;
}
.adv-parent-temp-wrapper-list-widget .adv-parent-acc-list .advanced-list-template-wrapper .right-actions-content {
  flex-shrink: 0;
  gap: 10px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.adv-parent-temp-wrapper-list-widget .adv-parent-acc-list .advanced-list-template-wrapper .right-actions-content h1 {
  color: var(--sdk-gloabl-text-color);
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
}
.adv-parent-temp-wrapper-list-widget .adv-parent-acc-list .advanced-list-template-wrapper .right-actions-content .tag-status {
  display: flex;
  padding: 2px 6px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 4px;
  background: var(--sdk-gloabl-bg-secondary);
  color: var(--green-2, #27AE60);
  font-size: 10px;
  font-weight: 400;
  line-height: 17px;
  margin: 0;
  border: 1px solid transparent;
}
.adv-parent-temp-wrapper-list-widget .adv-parent-acc-list .advanced-list-template-wrapper .right-actions-content .dropdown-list-wrapper {
  width: auto;
  position: relative;
}
.adv-parent-temp-wrapper-list-widget .adv-parent-acc-list .advanced-list-template-wrapper .right-actions-content .dropdown-list-wrapper.show-drp .elipse-dropdown {
  background: var(--sdk-gloabl-bg-secondary);
}
.adv-parent-temp-wrapper-list-widget .adv-parent-acc-list .advanced-list-template-wrapper .right-actions-content .dropdown-list-wrapper.show-drp .drp-content-menu {
  display: block;
}
.adv-parent-temp-wrapper-list-widget .adv-parent-acc-list .advanced-list-template-wrapper .right-actions-content .dropdown-list-wrapper .elipse-dropdown {
  width: 24px;
  height: 24px;
  border: 0;
  background: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  font-size: 14px;
  border-radius: 4px;
  transition: 0.2s all ease;
}
.adv-parent-temp-wrapper-list-widget .adv-parent-acc-list .advanced-list-template-wrapper .right-actions-content .dropdown-list-wrapper .elipse-dropdown svg path {
  fill: var(--sdk-gloabl-text-color);
}
.adv-parent-temp-wrapper-list-widget .adv-parent-acc-list .advanced-list-template-wrapper .right-actions-content .dropdown-list-wrapper .elipse-dropdown:hover {
  background: var(--sdk-gloabl-bg-secondary);
}
.adv-parent-temp-wrapper-list-widget .adv-parent-acc-list .adv-list-temp-accordion {
  padding: 10px;
  -webkit-animation-name: slideOutDown;
  animation-name: slideOutDown;
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
  display: none;
  position: relative;
  z-index: 2;
}
.adv-parent-temp-wrapper-list-widget .adv-parent-acc-list .adv-list-temp-accordion.button-z-index-3 {
  z-index: 3;
}
.adv-parent-temp-wrapper-list-widget .adv-parent-acc-list .adv-list-temp-accordion .list-of-rows {
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 8px;
}
.adv-parent-temp-wrapper-list-widget .adv-parent-acc-list .adv-list-temp-accordion .list-of-rows .row-list-info {
  display: flex;
  align-items: flex-start;
  gap: 14px;
}
.adv-parent-temp-wrapper-list-widget .adv-parent-acc-list .adv-list-temp-accordion .list-of-rows .row-list-info figure {
  line-height: 0;
  position: relative;
  top: 2px;
}
.adv-parent-temp-wrapper-list-widget .adv-parent-acc-list .adv-list-temp-accordion .list-of-rows .row-list-info figure img {
  width: 16px;
  height: 16px;
}
.adv-parent-temp-wrapper-list-widget .adv-parent-acc-list .adv-list-temp-accordion .list-of-rows .row-list-info p {
  color: var(--sdk-gloabl-text-color);
  font-size: 12px;
  font-weight: 500;
  line-height: 19px;
  letter-spacing: 0.3px;
}
.adv-parent-temp-wrapper-list-widget .adv-parent-acc-list .adv-list-temp-accordion .buttons-wrapper-sec {
  display: flex;
  gap: 10px;
  margin-top: 10px;
  position: relative;
}
.adv-parent-temp-wrapper-list-widget .adv-parent-acc-list .adv-list-temp-accordion .buttons-wrapper-sec.if-full-width-buttons {
  flex-wrap: wrap;
}
.adv-parent-temp-wrapper-list-widget .adv-parent-acc-list .adv-list-temp-accordion .buttons-wrapper-sec.auto-adjust {
  flex-wrap: wrap;
}
.adv-parent-temp-wrapper-list-widget .adv-parent-acc-list .adv-list-temp-accordion .buttons-wrapper-sec.auto-adjust button {
  width: auto;
}
.adv-parent-temp-wrapper-list-widget .adv-parent-acc-list .adv-list-temp-accordion .buttons-wrapper-sec.hide {
  display: none;
}
.adv-parent-temp-wrapper-list-widget .adv-parent-acc-list .adv-list-temp-accordion .table-list-data {
  display: flex;
  flex-wrap: wrap;
}
.adv-parent-temp-wrapper-list-widget .adv-parent-acc-list .adv-list-temp-accordion .table-list-data.if-column-type .table-body-data {
  flex: 1 1 50%;
  flex-direction: row;
  align-items: center;
}
.adv-parent-temp-wrapper-list-widget .adv-parent-acc-list .adv-list-temp-accordion .table-list-data .table-body-data {
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  flex: 1 1 33.333%;
  padding: 10px;
  gap: 10px;
}
.adv-parent-temp-wrapper-list-widget .adv-parent-acc-list .adv-list-temp-accordion .table-list-data .table-body-data .img_block {
  flex-shrink: 0;
  width: 30px;
  height: 30px;
}
.adv-parent-temp-wrapper-list-widget .adv-parent-acc-list .adv-list-temp-accordion .table-list-data .table-body-data .img_block.xs {
  width: 16px;
  height: 16px;
}
.adv-parent-temp-wrapper-list-widget .adv-parent-acc-list .adv-list-temp-accordion .table-list-data .table-body-data .img_block.md {
  width: 40px;
  height: 40px;
}
.adv-parent-temp-wrapper-list-widget .adv-parent-acc-list .adv-list-temp-accordion .table-list-data .table-body-data .img_block.lg {
  width: 60px;
  height: 60px;
}
.adv-parent-temp-wrapper-list-widget .adv-parent-acc-list .adv-list-temp-accordion .table-list-data .table-body-data .img_block.xlg {
  width: 80px;
  height: 80px;
}
.adv-parent-temp-wrapper-list-widget .adv-parent-acc-list .adv-list-temp-accordion .table-list-data .table-body-data .img_block figure {
  line-height: 0px;
}
.adv-parent-temp-wrapper-list-widget .adv-parent-acc-list .adv-list-temp-accordion .table-list-data .table-body-data .img_block img {
  width: 100%;
  height: 100%;
  border-radius: 8px;
}
.adv-parent-temp-wrapper-list-widget .adv-parent-acc-list .adv-list-temp-accordion .table-list-data .table-body-data .img_block img.radius-100 {
  border-radius: 100%;
}
.adv-parent-temp-wrapper-list-widget .adv-parent-acc-list .adv-list-temp-accordion .table-list-data .table-body-data .titles_info_block {
  width: 100%;
}
.adv-parent-temp-wrapper-list-widget .adv-parent-acc-list .adv-list-temp-accordion .table-list-data .table-body-data .titles_info_block p {
  color: var(--sdk-gloabl-text-color);
  font-size: 14px;
  font-weight: 400;
  line-height: normal;
  margin-bottom: 2px;
}
.adv-parent-temp-wrapper-list-widget .adv-parent-acc-list .adv-list-temp-accordion .table-list-data .table-body-data .titles_info_block h1 {
  color: var(--sdk-gloabl-text-color);
  font-size: 14px;
  font-weight: 600;
  line-height: normal;
  letter-spacing: 0.271px;
}
.adv-parent-temp-wrapper-list-widget .adv-parent-acc-list .adv-list-temp-accordion .arrow-icon {
  font-size: 10px;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 0;
  background: transparent;
  padding: 0;
  cursor: pointer;
}
.adv-parent-temp-wrapper-list-widget .adv-parent-acc-list .adv-list-temp-accordion .arrow-icon svg path {
  fill: var(--sdk-gloabl-text-color);
}
.adv-parent-temp-wrapper-list-widget .adv-parent-acc-list .adv-list-temp-accordion .arrow-icon.rotate {
  transform: rotate(90deg);
}
.adv-parent-temp-wrapper-list-widget .see-more-link {
  padding: 10px;
  text-align: right;
}
.adv-parent-temp-wrapper-list-widget .see-more-link .see-more-btn {
  display: inline-flex;
  padding: 5px 10px;
  align-items: center;
  gap: 10px;
  border: 0;
  color: var(--sdk-global-theme-color);
  text-align: center;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  background: transparent;
  height: 34px;
}
.adv-parent-temp-wrapper-list-widget .see-more-link .see-more-btn svg path {
  fill: var(--sdk-gloabl-text-color);
}`, "",{"version":3,"sources":["webpack://./src/templatemanager/templates/listWidget/listWidget.scss"],"names":[],"mappings":"AAAA;EACI,yBAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EACA,SAAA;AACJ;;AAEA;EACI,qBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yFAAA;EACA,sCAAA;AACJ;AAGgB;EACI,aAAA;AADpB;AAIY;EACI,WAAA;EACA,kBAAA;EACA,wBAAA;EACA,WAAA;EACA,0CAAA;EACA,SAAA;EACA,UAAA;AAFhB;AAMI;EACI,iBAAA;EACA,aAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;AAJR;AAKQ;EACI,SAAA;EACA,mCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,mDAAA;EACA,sCAAA;EACA,yBAAA;AAHZ;AAIY;EACI,sDAAA;AAFhB;AAIY;EACI,sDAAA;AAFhB;AAMI;EACI,aAAA;EACA,kBAAA;EACA,UAAA;EACA,QAAA;EACA,UAAA;EACA,gDAAA;EACA,0FAAA;EACA,sCAAA;EACA,eAAA;EACA,SAAA;EACA,kBAAA;EACA,YAAA;AAJR;AAKQ;EACI,YAAA;EACA,SAAA;EACA,UAAA;EACA,uBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,WAAA;AAHZ;AAKgB;EACI,kCAAA;AAHpB;AAOQ;EACI,8BAAA;EACA,sCAAA;EACA,aAAA;EACA,iBAAA;EACA,WAAA;EACA,mBAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;EACA,yBAAA;EACA,qBAAA;AALZ;AAQI;EACI,aAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;AANR;AAOQ;EACI,mCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,WAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;AALZ;AAOQ;EACI,UAAA;EACI,mBAAA;EACA,eAAA;EACA,sBAAA;EACA,cAAA;EACA,uBAAA;AALhB;AAOQ;EACI,aAAA;EACA,mBAAA;EACA,cAAA;EACA,SAAA;EACA,kBAAA;AALZ;AAQI;EACI,qBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;AANR;AAUoB;EACI,wBAAA;AARxB;AAYY;EACI,cAAA;AAVhB;AAaQ;EACI,WAAA;EACA,aAAA;EACA,mBAAA;EACA,aAAA;EACA,SAAA;AAXZ;AAYY;EACI,cAAA;EACA,WAAA;EACA,YAAA;AAVhB;AAWgB;EACI,WAAA;EACA,YAAA;AATpB;AAWgB;EACI,WAAA;EACA,YAAA;AATpB;AAWgB;EACI,WAAA;EACA,YAAA;AATpB;AAWgB;EACI,gBAAA;AATpB;AAWgB;EACI,WAAA;EACA,YAAA;EACA,kBAAA;AATpB;AAUoB;EACI,mBAAA;AARxB;AAYY;EACI,WAAA;AAVhB;AAcgB;EACI,mCAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;AAZpB;AAkBgB;EACI,mCAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;AAhBpB;AAuBY;EACI,cAAA;EACA,SAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;AArBhB;AAsBgB;EACI,mCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AApBpB;AAsBgB;EACI,aAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,0CAAA;EACA,8BAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,SAAA;EACA,6BAAA;AApBpB;AAsBgB;EACI,WAAA;EACA,kBAAA;AApBpB;AAsBwB;EACI,0CAAA;AApB5B;AAsBwB;EACI,cAAA;AApB5B;AAuBoB;EACI,WAAA;EACA,YAAA;EACA,SAAA;EACA,uBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;EACA,eAAA;EACA,kBAAA;EACA,yBAAA;AArBxB;AAuB4B;EACI,kCAAA;AArBhC;AAwBwB;EACI,0CAAA;AAtB5B;AA4BQ;EACI,aAAA;EACA,oCAAA;EACA,4BAAA;EACA,8BAAA;EACA,sBAAA;EACA,iCAAA;EACA,yBAAA;EACA,aAAA;EACA,kBAAA;EACA,UAAA;AA1BZ;AA2BY;EACI,UAAA;AAzBhB;AA2BY;EACI,aAAA;EACA,sBAAA;EACA,WAAA;EACA,QAAA;AAzBhB;AA0BgB;EACI,aAAA;EACA,uBAAA;EACA,SAAA;AAxBpB;AAyBoB;EACI,cAAA;EACA,kBAAA;EACA,QAAA;AAvBxB;AAwBwB;EACI,WAAA;EACA,YAAA;AAtB5B;AAyBoB;EACI,mCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,qBAAA;AAvBxB;AA2BY;EACI,aAAA;EACA,SAAA;EACA,gBAAA;EACA,kBAAA;AAzBhB;AA0BgB;EACI,eAAA;AAxBpB;AA0BgB;EACI,eAAA;AAxBpB;AAyBoB;EACI,WAAA;AAvBxB;AA0BgB;EACI,aAAA;AAxBpB;AA2BY;EACI,aAAA;EACA,eAAA;AAzBhB;AA2BoB;EACI,aAAA;EACA,mBAAA;EACA,mBAAA;AAzBxB;AA4BgB;EACI,aAAA;EACA,uBAAA;EACA,sBAAA;EACA,iBAAA;EACA,aAAA;EACA,SAAA;AA1BpB;AA2BoB;EACI,cAAA;EACA,WAAA;EACA,YAAA;AAzBxB;AA0BwB;EACI,WAAA;EACA,YAAA;AAxB5B;AA0BwB;EACI,WAAA;EACA,YAAA;AAxB5B;AA0BwB;EACI,WAAA;EACA,YAAA;AAxB5B;AA0BwB;EACI,WAAA;EACA,YAAA;AAxB5B;AA0BwB;EACI,gBAAA;AAxB5B;AA0BwB;EACI,WAAA;EACA,YAAA;EACA,kBAAA;AAxB5B;AAyB4B;EACI,mBAAA;AAvBhC;AA2BoB;EACI,WAAA;AAzBxB;AA0BwB;EACI,mCAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;AAxB5B;AA0BwB;EACI,mCAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;AAxB5B;AA6BY;EACI,eAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,uBAAA;EACA,UAAA;EACA,eAAA;AA3BhB;AA6BoB;EACI,kCAAA;AA3BxB;AA8BgB;EACI,wBAAA;AA5BpB;AAiCI;EACI,aAAA;EACA,iBAAA;AA/BR;AAgCQ;EACI,oBAAA;EACA,iBAAA;EACA,mBAAA;EACA,SAAA;EACA,SAAA;EACA,oCAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;EACA,YAAA;AA9BZ;AAgCgB;EACI,kCAAA;AA9BpB","sourcesContent":[".padding-wrapper-content-list-widget{\n    padding: 0 10px 16px 16px;\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    gap: 10px;\n}\n\n.adv-parent-temp-wrapper-list-widget{\n    display: inline-block;\n    width: 100%;\n    height: 100%;\n    border-radius: 4px;\n    box-shadow: 0px 1px 2px -1px rgba(16, 24, 40, 0.10), 0px 1px 3px 0px rgba(16, 24, 40, 0.10);\n    background: var(--sdk-global-white-bg);\n    &.list-with-border-multi-items{\n        .adv-parent-acc-list{\n            &:last-child{\n                &::before{\n                    display: none;\n                }\n            }\n            &::before{\n                content: \"\";\n                position: absolute;\n                width: calc(100% - 20px);\n                height: 1px;\n                background: var(--sdk-gloabl-border-color);\n                bottom: 0;\n                left: 10px;\n            }\n        }\n    }\n    .tabs-sec-data{\n        padding: 0px 10px;\n        display: flex;\n        gap: 8px 16px;\n        flex-wrap: wrap;\n        margin-bottom: 10px;\n        .tab-name{\n            border: 0;\n            color: var(--sdk-gloabl-text-color);\n            font-size: 14px;\n            font-weight: 400;\n            line-height: 20px;\n            padding: 10px 12px;\n            min-width: 44px;\n            min-height: 44px;\n            border-bottom: 2px solid var(--sdk-global-white-bg);\n            background: var(--sdk-global-white-bg);\n            transition: 0.3s all ease;\n            &:hover{\n                border-bottom: 2px solid var(--sdk-global-theme-color);\n            }\n            &.active-tab{\n                border-bottom: 2px solid var(--sdk-global-theme-color);\n            }\n        }\n    }\n    .drp-content-menu{\n        display: none;\n        position: absolute;\n        left: auto;\n        right: 0;\n        z-index: 9;\n        border: 1px solid var(--sdk-gloabl-border-color);\n        box-shadow: 0px 2px 4px -2px rgba(16, 24, 40, 0.10), 0px 4px 6px -1px rgba(16, 24, 40, 0.10);\n        background: var(--sdk-global-white-bg);\n        margin-top: 2px;\n        top: 34px;\n        border-radius: 4px;\n        width: 200px;\n        .close-drp-down{\n            float: right;\n            border: 0;\n            padding: 0;\n            background: transparent;\n            font-size: 14px;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            width: 20px;\n            height: 20px;\n            cursor: pointer;\n            margin: 5px;\n            svg{\n                path{\n                    fill: var(--sdk-gloabl-text-color);\n                }\n            }\n        }\n        li{\n            border-radius: 4px 4px 0px 0px;\n            background: var(--sdk-global-white-bg);\n            display: flex;\n            padding: 5px 16px;\n            width: 100%;\n            align-items: center;\n            align-self: stretch;\n            gap: 10px;\n            cursor: pointer;\n            transition: 0.2s all ease;\n            list-style-type: none;\n        }\n    }\n    .main-heading-wrapper{\n        padding: 10px;\n        display: flex;\n        align-items: center;\n        gap: 10px;\n        h1{\n            color: var(--sdk-gloabl-text-color);\n            font-size: 18px;\n            font-weight: 600;\n            line-height: 20px;\n            width: 100%;\n            overflow: hidden;\n            white-space: nowrap;\n            text-overflow: ellipsis;\n        }\n        p{\n            padding: 0;\n                white-space: normal;\n                font-size: 13px;\n                letter-spacing: 0.27px;\n                color: #8a959f;\n                text-overflow: ellipsis;\n        }\n        .header-actions{\n            display: flex;\n            align-items: center;\n            flex-shrink: 0;\n            gap: 10px;\n            position: relative;\n        }\n    }\n    .adv-parent-acc-list{\n        display: inline-block;\n        width: 100%;\n        height: 100%;\n        position: relative;\n        &.open-acc-adv-temp{\n            .advanced-list-template-wrapper{\n                .right-actions-content{\n                    .arrow-icon{\n                        transform: rotate(90deg);\n                    }\n                }\n            }\n            .adv-list-temp-accordion{\n                display: block;\n            }\n        }\n        .advanced-list-template-wrapper{\n            width: 100%;        \n            display: flex;\n            align-items: center;\n            padding: 10px;\n            gap: 15px;\n            .img-block{\n                flex-shrink: 0;\n                width: 40px;\n                height: 40px;\n                &.xs{\n                    width: 16px;\n                    height: 16px;\n                }\n                &.lg{\n                    width: 60px;\n                    height: 60px;     \n                }\n                &.xlg{\n                    width: 80px;\n                    height: 80px;\n                }\n                figure{\n                    line-height: 0px;\n                }\n                img{\n                    width: 100%;\n                    height: 100%;\n                    border-radius: 8px;\n                    &.radius-100{\n                        border-radius: 100%;\n                    }\n                }\n            }\n            .titles-info-block{\n                width: 100%;\n                // overflow: hidden;\n                // white-space: nowrap;\n                // text-overflow: ellipsis;\n                h1{\n                    color: var(--sdk-gloabl-text-color);\n                    font-size: 16px;\n                    font-weight: 600;\n                    line-height: normal;\n                    // overflow: hidden;\n                    // white-space: nowrap;\n                    // text-overflow: ellipsis;\n                    // width: 100%;\n                }\n                p{\n                    color: var(--sdk-gloabl-text-color);\n                    font-size: 14px;\n                    font-weight: 400;\n                    line-height: normal;\n                    letter-spacing: 0.271px;\n                    // overflow: hidden;\n                    // white-space: nowrap;\n                    // text-overflow: ellipsis;\n                    // width: 100%;\n                }\n            }\n            .right-actions-content{\n                flex-shrink: 0;\n                gap: 10px;\n                display: flex;\n                align-items: center;\n                justify-content: flex-end;\n                h1{\n                    color: var(--sdk-gloabl-text-color);\n                    font-size: 14px;\n                    font-weight: 600;\n                    line-height: 20px;\n                }\n                .tag-status{\n                    display: flex;\n                    padding: 2px 6px;\n                    justify-content: center;\n                    align-items: center;\n                    gap: 10px;\n                    border-radius: 4px;\n                    background: var(--sdk-gloabl-bg-secondary);\n                    color: var(--green-2, #27AE60);\n                    font-size: 10px;\n                    font-weight: 400;\n                    line-height: 17px;\n                    margin: 0;\n                    border: 1px solid transparent;\n                }\n                .dropdown-list-wrapper{\n                    width: auto;\n                    position: relative;\n                    &.show-drp{\n                        .elipse-dropdown{\n                            background: var(--sdk-gloabl-bg-secondary);\n                        }\n                        .drp-content-menu{\n                            display: block;\n                        }\n                    }\n                    .elipse-dropdown{\n                        width: 24px;\n                        height: 24px;\n                        border: 0;\n                        background: transparent;\n                        display: flex;\n                        align-items: center;\n                        justify-content: center;\n                        padding: 0;\n                        font-size: 14px;\n                        border-radius: 4px;\n                        transition: 0.2s all ease;\n                        svg{\n                            path{\n                                fill: var(--sdk-gloabl-text-color);\n                            }\n                        }\n                        &:hover{\n                            background: var(--sdk-gloabl-bg-secondary);\n                        }\n                    }                \n                }\n            }\n        }\n        .adv-list-temp-accordion{\n            padding: 10px;\n            -webkit-animation-name: slideOutDown;\n            animation-name: slideOutDown;\n            -webkit-animation-duration: 1s;\n            animation-duration: 1s;\n            -webkit-animation-fill-mode: both;\n            animation-fill-mode: both;\n            display: none;\n            position: relative;\n            z-index: 2;\n            &.button-z-index-3{\n                z-index: 3;\n            }\n            .list-of-rows{\n                display: flex;\n                flex-direction: column;\n                width: 100%;\n                gap: 8px;\n                .row-list-info{\n                    display: flex;\n                    align-items: flex-start;\n                    gap: 14px;\n                    figure{\n                        line-height: 0;\n                        position: relative;\n                        top: 2px;\n                        img{\n                            width: 16px;\n                            height: 16px;\n                        }\n                    }\n                    p{\n                        color: var(--sdk-gloabl-text-color);\n                        font-size: 12px;\n                        font-weight: 500;\n                        line-height: 19px;\n                        letter-spacing: 0.3px;\n                    }\n                }\n            }\n            .buttons-wrapper-sec{\n                display: flex;\n                gap: 10px;\n                margin-top: 10px;    \n                position: relative; \n                &.if-full-width-buttons{\n                    flex-wrap: wrap;\n                }  \n                &.auto-adjust{\n                    flex-wrap: wrap;\n                    button{\n                        width: auto;\n                    }\n                }  \n                &.hide {\n                    display: none;\n                }   \n            }\n            .table-list-data{\n                display: flex;\n                flex-wrap: wrap;\n                &.if-column-type{\n                    .table-body-data{\n                        flex: 1 1 50%;\n                        flex-direction: row;\n                        align-items: center;\n                    }\n                }\n                .table-body-data{\n                    display: flex;\n                    align-items: flex-start;\n                    flex-direction: column;\n                    flex: 1 1 33.333%;\n                    padding: 10px;\n                    gap: 10px;\n                    .img_block{\n                        flex-shrink: 0;\n                        width: 30px;\n                        height: 30px;\n                        &.xs{\n                            width: 16px;\n                            height: 16px;\n                        }\n                        &.md{\n                            width: 40px;\n                            height: 40px;\n                        }\n                        &.lg{\n                            width: 60px;\n                            height: 60px;     \n                        }\n                        &.xlg{\n                            width: 80px;\n                            height: 80px;\n                        }\n                        figure{\n                            line-height: 0px;\n                        }\n                        img{\n                            width: 100%;\n                            height: 100%;\n                            border-radius: 8px;\n                            &.radius-100{\n                                border-radius: 100%;\n                            }\n                        }\n                    }\n                    .titles_info_block{\n                        width: 100%;\n                        p{\n                            color: var(--sdk-gloabl-text-color);\n                            font-size: 14px;\n                            font-weight: 400;\n                            line-height: normal;\n                            margin-bottom: 2px;\n                        }\n                        h1{\n                            color: var(--sdk-gloabl-text-color);\n                            font-size: 14px;\n                            font-weight: 600;\n                            line-height: normal;\n                            letter-spacing: 0.271px;\n                        }\n                    }\n                }\n            }\n            .arrow-icon{\n                font-size: 10px;\n                width: 20px;\n                height: 20px;\n                display: flex;\n                align-items: center;\n                justify-content: center;\n                border: 0;\n                background: transparent;\n                padding: 0;\n                cursor: pointer;\n                svg{\n                    path{\n                        fill: var(--sdk-gloabl-text-color);\n                    }\n                }\n                &.rotate {\n                    transform: rotate(90deg);\n                }\n            }\n        }\n    }\n    .see-more-link{\n        padding: 10px;\n        text-align: right;\n        .see-more-btn{\n            display: inline-flex;\n            padding: 5px 10px;\n            align-items: center;\n            gap: 10px;\n            border: 0;\n            color: var(--sdk-global-theme-color);\n            text-align: center;\n            font-size: 14px;\n            font-weight: 400;\n            line-height: 20px;\n            background: transparent;\n            height: 34px;\n            svg{\n                path{\n                    fill: var(--sdk-gloabl-text-color);\n                }\n            }\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
